/**
 * Build up to two uppercase initials from a name: the first letter of each of the first two
 * whitespace-separated words. Returns an empty string for a blank name.
 */
export function getInitials(name: string): string {
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('');
}
